import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert } from 'lucide-react';
export function QualityAssurance() {
  return <section className="py-20 px-4" data-id="element-61" data-mp="2dnjm1s810pfa">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto bg-zinc-950 border border-red-900/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-62" data-mp="2dobfawe5ib2e">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-red-500/10 blur-[50px] rounded-full pointer-events-none" data-id="element-63" data-mp="2wk1mqz4urzno" />

        <ShieldAlert className="w-12 h-12 text-red-500 mx-auto mb-6 relative z-10" data-id="element-64" data-mp="3ae2br16068au" />
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white relative z-10" data-id="element-65" data-mp="35f7va5vicvtw">
          Commitment to Excellence
        </h2>

        <div className="space-y-5 text-gray-400 leading-relaxed relative z-10 text-lg" data-id="element-66" data-mp="3fbkl2snxmpjd">
          <p data-id="element-67" data-mp="15gmkr0oqgivc">We provide the blueprint; you provide the execution.</p>
          <p data-id="element-68" data-mp="15ih78jfnkj1j">
            Because this is a digital product delivered instantly,{' '}
            <strong className="text-red-400" data-id="element-69" data-mp="1ag94zu2zazdn">all sales are final.</strong> We
            don't offer refunds for the same reason a professor doesn't refund
            tuition if you don't study: the value is in the information and your
            commitment to it.
          </p>
          <p className="text-white font-medium pt-4 border-t border-white/10 mt-6" data-id="element-70" data-mp="1oefo2439qut9">
            If you are ready to take your biology seriously and follow a proven
            system, this is for you. Welcome to the elite.
          </p>
        </div>
      </motion.div>
    </section>;
}